<template>
  <canvas id="myChartPie" width="auto" height="auto"></canvas>
</template>

<script>
var Chart = require("chart.js");
export default {
  props: {
    whatsapp: {
      type: Object,
      require: true
    },
    widget: {
      type: Object,
      require: true
    }
  },
  components: {},
  data() {
    return {
      ctx: "",
      Chart: Chart,
      whats: {},
      tele: {}
    };
  },
  computed: {},
  mounted() {
    this.buildChart();
  },
  methods: {
    validateData() {
      if (this.whatsapp.total && this.widget.total) return true;
      return false;
    },
    buildChart() {
      if (this.validateData) {
        let ctxPie = document.getElementById("myChartPie");
        if (this.ctx) this.ctx.destroy();
        this.ctx = new Chart(ctxPie, {
          type: "pie",
          data: {
            labels: ["Whatsapp", "Widget"],
            datasets: [
              {
                label: "# of Votes",
                data: [this.whatsapp.total, this.widget.total],
                backgroundColor: ["#8FE77A", "#2792E8"],
                borderColor: ["#31FF00", "#00DEFF"],
                borderWidth: 1
              }
            ]
          },
          options: {
            legend: false,
            backgroundColor: "grey"
          }
        });
      }
    }
  }
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
</style>
